// Copy and metrics for the tertiary-navigation AI prompt. Kept here rather than inline so a
// consuming page can override any of them through the control config without restating defaults.

export const TERTIARY_NAVIGATION_AI_PROMPT_PLACEHOLDER = 'How can I help you?';

// U+21B5, the same glyph the tertiary search field already ships as its submit hint.
export const TERTIARY_NAVIGATION_AI_PROMPT_SUBMIT_HINT = 'Press ↵';

// Replaces the submit hint while a request is in flight. The summary assistant round trip runs
// several seconds because it also reloads the grid.
export const TERTIARY_NAVIGATION_AI_PROMPT_BUSY_HINT = 'Working…';

export const TERTIARY_NAVIGATION_AI_PROMPT_ARIA_LABEL = 'Ask AI';
export const TERTIARY_NAVIGATION_AI_PROMPT_PANEL_ARIA_LABEL = 'AI prompt';
export const TERTIARY_NAVIGATION_AI_PROMPT_SUBMIT_ARIA_LABEL = 'Submit AI request';

// Roughly eight lines of text before the textarea starts scrolling internally.
export const TERTIARY_NAVIGATION_AI_PROMPT_MAX_ROWS = 8;

// Design width of the floating panel at zoom 1. The styles express it as a ratio of the action
// height so it tracks the bar's zoom.
export const TERTIARY_NAVIGATION_AI_PROMPT_WIDTH_PX = 360;

// The panel sits on white, so it uses the colour mark rather than the white-on-gradient one.
export const TERTIARY_NAVIGATION_AI_PROMPT_ICON_SRC = '/images/scalar_ai.png';

// Press feedback flash on the submit hint, matching the search field.
export const TERTIARY_NAVIGATION_AI_PROMPT_HINT_ACTIVE_MS = 80;
